module.exports = __webpack_public_path__ + "static/media/IMG_0245.1e7f0f45.JPG";